import React from 'react';
import { positioning } from '../data/siteContent';

/**
 * The app's own "Lexeme is not…" framing, borrowed from its App Store FAQ.
 * Stating the refusals up front does more work than another feature list.
 */
const PositioningSection: React.FC = () => {
  return (
    <section className="section-y">
      <div className="shell">
        <div className="rule mb-14" />
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-5">
            <h2 className="display-lg text-[2rem] sm:text-[2.6rem]">{positioning.title}</h2>
            <p className="prose-reading mt-6">{positioning.body}</p>
          </div>

          <dl className="grid gap-px bg-ink/12 sm:grid-cols-2 lg:col-span-7">
            {positioning.notList.map((item) => (
              <div key={item.name} className="bg-background p-6 sm:p-7">
                <dt className="font-display text-lg text-ink" style={{ fontVariationSettings: '"opsz" 72, "WONK" 1' }}>
                  {item.name}
                </dt>
                <dd className="prose-note mt-2.5 text-[0.9375rem]">{item.body}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default PositioningSection;
